import PaperTexture from '../../../assets/paper_texture_small.png';
import Tape from '../../../assets/tape-145367.svg';

import './TapedPaper.css';

function TapedPaper({ children }) {
    return (
        <div className="taped-paper">
            <div className="paper-texture" style={{ backgroundImage: `url(${PaperTexture})` }}>
                {children}
            </div>

            <img src={Tape} alt="Tape" className="tape tape-top-left"/>
            <img src={Tape} alt="Tape" className="tape tape-top-right"/>
            <img src={Tape} alt="Tape" className="tape tape-bottom-left"/>
            <img src={Tape} alt="Tape" className="tape tape-bottom-right"/>
        </div>
    );
}

export default TapedPaper;